import React from 'react';
import PropTypes from 'prop-types';

import './skeleton.scss';

export function SkeletonSelect(
  {
    label = ''
  }
) {
  return (
    <div>
      <label
        className="form-label"
      >
        {label}
      </label>
      <div className="placeholder-select-line placeholder-animated-background " />
    </div>
  );
}

SkeletonSelect.propTypes = {
  label: PropTypes.string
};

export default SkeletonSelect;
